var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailInCirculeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 18.375h-22.75a.874.874 0 00-.875.875v17.5c0 .484.391.875.875.875h22.75a.874.874 0 00.875-.875v-17.5a.874.874 0 00-.875-.875zm-1.094 3.03v14.251H17.72V21.405l-.755-.588 1.075-1.381 1.17.91h17.585l1.17-.91 1.075 1.38-.758.589zm-1.487-1.061L28 27.18l-8.794-6.836-1.17-.91-1.075 1.38.755.588 9.34 7.262a1.532 1.532 0 001.88 0l9.345-7.26.755-.587-1.075-1.381-1.167.908z",
    fill: "#597EF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 26,
    stroke: "#F0F5FF",
    strokeWidth: 4
  })));
}

export default __webpack_public_path__ + "./fonts/email-in-circule-icon.16a82df2e92018e911f6d5fde8994aaf.svg";
export { SvgEmailInCirculeIcon as ReactComponent };